import { render, staticRenderFns } from "./ProfessionalServicesCard.vue?vue&type=template&id=9ed3468c&scoped=true&"
import script from "./ProfessionalServicesCard.vue?vue&type=script&lang=js&"
export * from "./ProfessionalServicesCard.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionalServicesCard.vue?vue&type=style&index=0&id=9ed3468c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed3468c",
  null
  
)

export default component.exports